import { instrumentTypeLabel } from './instrument-types.js';

export const OPERATIONS_LIST_PATH = '/ops/my-pos';

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function readOperationsListFilters(paramsLike) {
  const params = paramsLike instanceof URLSearchParams
    ? paramsLike
    : new URLSearchParams(paramsLike || '');
  const technicianId = String(params.get('tech') || '').trim();
  return {
    technicianId: UUID_PATTERN.test(technicianId) ? technicianId : '',
    search: String(params.get('q') || '').trim(),
  };
}

export function buildOperationsListPath({ technicianId = '', search = '' } = {}) {
  const params = new URLSearchParams();
  const normalizedTechId = String(technicianId || '').trim();
  const normalizedSearch = String(search || '').trim();
  if (UUID_PATTERN.test(normalizedTechId)) params.set('tech', normalizedTechId);
  if (normalizedSearch) params.set('q', normalizedSearch);
  const query = params.toString();
  return query ? `${OPERATIONS_LIST_PATH}?${query}` : OPERATIONS_LIST_PATH;
}

export function resolveOperationsReturnPath(value) {
  const candidate = String(value || '').trim();
  if (candidate === OPERATIONS_LIST_PATH || candidate.startsWith(`${OPERATIONS_LIST_PATH}?`)) {
    return candidate;
  }
  return OPERATIONS_LIST_PATH;
}

export function equipmentTypeLabel(instrument = {}) {
  const category = String(
    instrument.instrument_category_name ||
    instrument.category_name ||
    instrument.category?.name ||
    '',
  ).trim();
  return category || instrumentTypeLabel(instrument.instrument_type || instrument.type);
}
